import Model from "./Model";

class Broadcast extends Model {
      getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }

    getServiceId() {
        return this.attrs.serviceId;
    }
    
    setServiceId(value) {
        this.attrs.serviceId = value;
        return this;
    }

    getBroadCastName() {
        return this.attrs.broadcastName;
    }
    
    setBroadCastName(value) {
        this.attrs.broadcastName = value;
        return this;
    }
    getScheduleDate() {
        return this.attrs.scheduleDate;
    }
    
    setScheduleDate(value) {
        this.attrs.scheduleDate = value;
        return this;
    }
    getSelectedTemplate() {
        return this.attrs.selectedTemplate;
    }
    
    setSelectedTemplate(value) {
        this.attrs.selectedTemplate = value;
        return this;
    }
    getSelectedContacts() {
        return this.attrs.selectedContacts;
    }
    
    setSelectedContacts(value) {
        this.attrs.selectedContacts = value;
        return this;
    }
    getSelectedGroups() {
        return this.attrs.selectedGroups;
    }
    
    setSelectedGroups(value) {
        this.attrs.selectedGroups = value;
        return this;
    }
    getSendNow() {
        return this.attrs.sendNow;
    }
    
    setSendnow(value) {
        this.attrs.sendNow = value;
        return this;
    }
    getSuccess() {
        return this.attrs.success;
    }
    
    setSuccess(value) {
        this.attrs.success = value;
        return this;
    }
     getFailed() {
        return this.attrs.failed;
    }
    
    setFailed(value) {
        this.attrs.failed = value;
        return this;
    }
     getRead() {
        return this.attrs.read;
    }
    
    setRead(value) {
        this.attrs.read = value;
        return this;
    }
     getReplied() {
        return this.attrs.replied;
    }
    
    setReplied(value) {
        this.attrs.replied = value;
        return this;
    }
     getRecipients() {
        return this.attrs.recipients;
    }
    
    setRecipients(value) {
        this.attrs.recipients = value;
        return this;
    }
     getStatus() {
        return this.attrs.status;
    }
    
    setStatus(value) {
        this.attrs.status = value;
        return this;
    }
     getTemplateVariables() {
        return this.attrs.templateVariables;
    }
    
    setTemplateVariables(value) {
        this.attrs.templateVariables = value;
        return this;
    }
}
export default Broadcast;